module.exports = __webpack_public_path__ + "img/american-express.afbb2152.svg";